import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import { i18n } from '@international/mastodon-i18n';
import UploadField from '../fields/InputFile/UploadField';
import { MAX_FILE_SIZE } from '../../constants';

const PREFIX =
  'components.Report.Verification.MatrixVerification.DrivingExperience.enhanced.upload';

const CHECKLIST_ITEM_COUNT = 5;

const MAX_FILE_SIZE_LABEL = `${Math.round(MAX_FILE_SIZE / (1024 * 1024))} MB`;

// replaceOnMax: single-slot field, so a re-upload replaces the current file
// instead of erroring on the limit.
const UPLOAD_OPTIONS = { maxFiles: 1, replaceOnMax: true };

const validateDocumentRequired = (value?: unknown[]) =>
  !value || value.length === 0
    ? i18n.getStr(`${PREFIX}.error.required`)
    : undefined;

export interface DrivingExperienceDocumentUploadProps {
  fieldKey: string;
}

const DrivingExperienceDocumentUpload = ({
  fieldKey,
}: DrivingExperienceDocumentUploadProps) => {
  const documentKey = `${fieldKey}.document`;

  return (
    <div className='dee-upload'>
      <p className='dee-upload__intro'>{i18n.getStr(`${PREFIX}.intro`)}</p>

      <M.InlineNotification
        kind='error'
        title=''
        subtitle={i18n.getStr(`${PREFIX}.warning`)}
        className='dee-upload__warning'
        hideCloseButton
      />

      <p className='dee-upload__checklist-title'>
        {i18n.getStr(`${PREFIX}.checklist.title`)}
      </p>
      <ul className='dee-upload__checklist'>
        {Array.from({ length: CHECKLIST_ITEM_COUNT }, (_, i) => (
          <li
            key={`dee-upload-check-${i}`}
            className='dee-upload__checklist-item'
          >
            <M.Icon icon='CheckmarkFilled' size={16} />
            <span>{i18n.getStr(`${PREFIX}.checklist.items.${i}`)}</span>
          </li>
        ))}
      </ul>

      <div className='dee-upload__box'>
        <span className='dee-upload__box-icon' aria-hidden='true'>
          <M.Icon icon='Upload' size={20} />
        </span>
        <UploadField
          name={documentKey}
          options={UPLOAD_OPTIONS}
          labelText={i18n.getStr(`${PREFIX}.box.label`, {
            maxSize: MAX_FILE_SIZE_LABEL,
          })}
          buttonText={i18n.getStr(`${PREFIX}.box.browse`)}
          validate={validateDocumentRequired}
        />
      </div>
    </div>
  );
};

export default i18n.renderTranslation()(DrivingExperienceDocumentUpload);
